import { render, staticRenderFns } from "./edit-password-dialog.vue?vue&type=template&id=30a2548f&"
import script from "./edit-password-dialog.vue?vue&type=script&lang=js&"
export * from "./edit-password-dialog.vue?vue&type=script&lang=js&"
import style0 from "./edit-password-dialog.vue?vue&type=style&index=0&id=30a2548f&prod&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports